import { createApp } from 'vue'; // Import createApp and App type
import store from './store/store'; // Assuming Vuex 4+ store
import Explore from "./Explore.vue";
import { i18n } from '../../i18n';

declare global {
  interface Window {
    typesenseUrl: string;
    typesenseSearchApiKey: string;
    country_id: number | null;
    region_id: number | null;
  }
}

const mountElement = document.querySelector('#explore_v2');

if (mountElement) {
  const newApp = createApp(Explore);
  newApp.use(store);
  newApp.use(i18n);
  newApp.mount('#explore_v2');
} else {
  console.warn('Mount element #explore_v2 not found.');
}
